import BaseStore from 'customer-flows/stores/base-store'
import { context } from 'customer-flows/utils/core'
import { getPriceMoney, getCandidatesForSlot } from 'customer-flows/utils/dynamic-pricing'

export default class RentalDynamicPricingStoreClass extends BaseStore {
  @context('tickets:selectableTickets') selectableTickets: TicketsStore['selectableTickets']

  getPricingEntry(priceEntry: AvailabilityTimePrice | undefined): AvailabilityTimePricing | undefined {
    if (!priceEntry?.pricing?.length) return undefined
    return priceEntry.pricing[0]
  }

  getTicketForSlot(slot: AvailabilityTime): Ticket | undefined {
    const candidates = getCandidatesForSlot(slot, this.selectableTickets)
    if (!candidates.length) return undefined
    return this.getLowestPricedTicket(candidates, slot) ?? candidates[0]
  }

  getDisplayPriceForDate(priceRange: Money[]): Money | null {
    return priceRange.reduce((lowest, current) =>
      parseFloat(current.amount) < parseFloat(lowest.amount) ? current : lowest
    )
  }

  private getLowestPricedTicket(candidates: Ticket[], slot: AvailabilityTime): Ticket | undefined {
    let lowestTicket: Ticket | undefined
    let lowestAmount = Infinity

    for (const ticket of candidates) {
      const priceEntry = slot.prices?.find((p) => p.resourceOptionId === ticket.id)
      const pricing = this.getPricingEntry(priceEntry)
      if (!pricing) continue

      const amount = parseFloat(getPriceMoney(pricing).amount)
      if (!isNaN(amount) && amount < lowestAmount) {
        lowestAmount = amount
        lowestTicket = ticket
      }
    }

    return lowestTicket
  }
}

declare global {
  export type RentalDynamicPricingStore = RentalDynamicPricingStoreClass
  export interface StoreRegistry {
    'dynamic-pricing/rental': RentalDynamicPricingStore
  }
}
